import React, { createContext, useState, useCallback } from 'react';

export const PDFViewerContext = createContext();

export const PDFViewerProvider = ({ children }) => {
  const [pdfData, setPdfData] = useState(null);
  const [filename, setFilename] = useState('document.pdf');
  const [isOpen, setIsOpen] = useState(false);

  const openPDF = useCallback((blob, name = 'document.pdf') => {
    setPdfData(blob);
    setFilename(name);
    setIsOpen(true);
  }, []);

  const closePDF = useCallback(() => {
    setIsOpen(false);
    setPdfData(null);
    setFilename('document.pdf');
  }, []);

  return (
    <PDFViewerContext.Provider value={{ pdfData, filename, isOpen, openPDF, closePDF }}>
      {children}
    </PDFViewerContext.Provider>
  );
};
